var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c_loading"},[_c('van-loading',{staticClass:"c-loading-content",attrs:{"color":"#0059C6"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }